<app-back-button
  class="back"
/>

@if (title(); as title) {
  <h1 class="title">{{ title }}</h1>
}
